import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset, MergeSource } from '../../decorators';
import { AccountContactMergeData, AccountMergeData, AttachmentsMergeData, AttachmentsMergeSchema, CompanyMergeData, EmployeeMergeData, EmployeeMergeSchema, JobSiteMergeData, OtherMergeData, OtherMergeDataSchema, StageIncludeItemsMergeData, StageIncludeItemsMergeDataSchema, StageMergeData } from '../data';
import { AccountContactMergeSchema } from '../data/account.contact.merge.data';
import { AccountMergeSchema } from '../data/account.merge.data';
import { CompanyMergeSchema } from '../data/company.merge.data';
import { JobSiteMergeSchema } from '../data/job.site.merge.data';
import { StageMergeSchema } from '../data/stage.merge.data';
import { TaskArrayMergeData, TaskArrayMergeDataSchema } from '../data/task.merge.data';

@MergeDataset({
    entity: ActivityEntityName.WorkOrder,
    dependsOn: [ActivityEntityName.Job]
})
export class StageMergeDataset {

    @MergeSource({
        schema: StageMergeSchema,
        ignoreFields: ['items']
    })
    stage: StageMergeData;

    @MergeSource({
        schema: JobSiteMergeSchema
    })
    stageSite: JobSiteMergeData;

    @MergeSource({
        schema: AccountMergeSchema
    })
    stageContractor: AccountMergeData;

    @MergeSource({
        schema: AccountContactMergeSchema
    })
    stageContractorContact: AccountContactMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    stageBillingCompany: CompanyMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    stageOwner: EmployeeMergeData;

    @MergeSource({
        schema: StageIncludeItemsMergeDataSchema,
        includeFields: ['items', 'subTotalBuy', 'subTotalSell'],
        ignoreCustomFields: true,
    })
    stageItem: StageIncludeItemsMergeData;

    @MergeSource({
        schema: AttachmentsMergeSchema,
        ignoreCustomFields: true,
    })
    stageAttachment: AttachmentsMergeData;

    @MergeSource({
        schema: AttachmentsMergeSchema,
        ignoreCustomFields: true,
    })
    files: AttachmentsMergeData;

    @MergeSource({
        schema: OtherMergeDataSchema,
    })
    other: OtherMergeData;

    @MergeSource({
        schema: TaskArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    stageTasks: TaskArrayMergeData;
}

